document.addEventListener('DOMContentLoaded', function () {
  function bindForm(formId, messageId) {
    const form = document.getElementById(formId)
    if (!form) return

    form.addEventListener('submit', function (e) {
      e.preventDefault()
      const ajaxUrl = `${window.location.origin}/wp/wp-admin/admin-ajax.php`
      const formData = new FormData(this)
      const submitButton = this.querySelector('button[type="submit"]')
      const spinner = submitButton.querySelector('.spinner')
      const buttonText = submitButton.querySelector('span')
      const formMessage = document.getElementById(messageId)

      spinner.classList.remove('hidden')
      buttonText.textContent = 'Skickar...'
      submitButton.disabled = true

      fetch(ajaxUrl, {
        method: 'POST',
        body: formData
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            formMessage.textContent = 'Formuläret har skickats!'
            formMessage.classList.remove('hidden', 'text-red-500')
            formMessage.classList.add('text-green-500')
            buttonText.textContent = 'Skickat!'
            form.reset()
          } else {
            formMessage.textContent = 'Ett fel uppstod: ' + (data.data || 'Okänt fel')
            formMessage.classList.remove('hidden', 'text-green-500')
            formMessage.classList.add('text-red-500')
            buttonText.textContent = 'Skicka'
          }
        })
        .catch(() => {
          formMessage.textContent = 'Ett fel uppstod vid skickandet.'
          formMessage.classList.remove('hidden', 'text-green-500')
          formMessage.classList.add('text-red-500')
          buttonText.textContent = 'Skicka'
        })
        .finally(() => {
          spinner.classList.add('hidden')
          submitButton.disabled = false
        })
    })
  }

  bindForm('offer-form', 'form-message')
  bindForm('product-quote-form', 'product-quote-message')
})
